module.exports = __webpack_public_path__ + "img/calendar.e341e19f.svg";